var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7467 12.0267L19.9733 13.2533L7.89333 25.3333H6.66667V24.1067L18.7467 12.0267ZM23.5467 4C23.2133 4 22.8667 4.13333 22.6133 4.38667L20.1733 6.82667L25.1733 11.8267L27.6133 9.38667C27.7369 9.26332 27.835 9.1168 27.9019 8.9555C27.9688 8.7942 28.0033 8.62129 28.0033 8.44667C28.0033 8.27204 27.9688 8.09913 27.9019 7.93783C27.835 7.77654 27.7369 7.63002 27.6133 7.50667L24.4933 4.38667C24.2267 4.12 23.8933 4 23.5467 4ZM18.7467 8.25333L4 23V28H9L23.7467 13.2533L18.7467 8.25333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.421212f084cd6b3b8c0ca636487b0408.svg";
export { ForwardRef as ReactComponent };